import { FC, memo } from 'react';

import { DateTimeDisplayMode } from './constants/DateTimeDisplayMode';
import { formatDateTime } from './logic/formatDateTime';
import { DateTimeDisplayProps } from './types/DateTimeDisplayProps';

const DateTimeDisplayComponent: FC<DateTimeDisplayProps> = ({
  value,
  mode = DateTimeDisplayMode.DateTime,
  fallback = 'N/A',
}) => {
  if (!value) return <>{fallback}</>;

  const formattedDisplayText = formatDateTime(value, mode);

  return <>{formattedDisplayText}</>;
};

export const DateTimeDisplay = memo(DateTimeDisplayComponent);
